import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { EnrollmentCancellationTraductionDto, EnrollmentTraductionDto } from "./enrollmentTraductionDto";

export class EnrollmentCancellationDto {
    idEnrollmentCancellationPattern?: number;
    codeCancellation?: string;
    active?: string;
    academicFee?: string;
    resourceRate?: string;
    administrativeFee?: string;
    additionalCancellationFee?: string;
    surcharge?: string;
    shortDescription?: string;
    typology?: string;
    enrollmentCancellationPatternTraductionDto?: EnrollmentCancellationTraductionDto[]

    constructor(data?: Partial<EnrollmentCancellationDto>) {
        Object.assign(this, data);
    }
}

export class EnrollmentCancellationResponse {
    enrollmentCancellationDto: EnrollmentCancellationDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class EnrollmentCancellationRequest {
    enrollmentCancellationDto: EnrollmentCancellationDto = new EnrollmentCancellationDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}